
seedWebApp.controller('OrderConfirmModalController', ['$scope', '$uibModalInstance', 'TranslationService', 'order',
    function OrderConfirmModalController($scope, $uibModalInstance, TranslationService, order) {

        $scope.translation = TranslationService.getActiveTranslation();
        $scope.order = order;
        console.log('OrderConfirmModalCtrl.order');
        console.log(order);        

        $scope.ok = function () {
            $uibModalInstance.close();
        };

        
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        
    }]
);